// extracted by mini-css-extract-plugin
export default {"root":"TableSort_root__W7R7j","button":"TableSort_button__2kb9G","active":"TableSort_active__04Uqv","separator":"TableSort_separator__RvHTD"};